module.exports = __webpack_public_path__ + "static/media/gepur.f9af4102.gif";